import { render, staticRenderFns } from "./IndexAccounting.vue?vue&type=template&id=b657d6be&scoped=true&"
import script from "./IndexAccounting.vue?vue&type=script&lang=js&"
export * from "./IndexAccounting.vue?vue&type=script&lang=js&"
import style0 from "./IndexAccounting.vue?vue&type=style&index=0&id=b657d6be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b657d6be",
  null
  
)

export default component.exports